exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".therapist-top-info__general-rating-container{display:-ms-flexbox;display:flex}@media (max-width:800px){.therapist-top-info__general-rating-container{-ms-flex-pack:center;justify-content:center}}.therapist-top-info__book-button{margin-top:2.5rem}", "", {"version":3,"sources":["/home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/pack/src/spa/Pages/Therapists/therapist-top-info.less"],"names":[],"mappings":"AACE,8CACE,oBAAA,YAAA,CAEA,yBASJ,8CARM,qBAAA,sBAAA,CAAA,CAIJ,iCACE,iBAAA,CAAA","file":"therapist-top-info.less","sourcesContent":[".therapist-top-info {\n  &__general-rating-container {\n    display: flex;\n\n    @media (max-width: 800px) {\n      justify-content: center;\n    }\n  }\n\n  &__book-button {\n    margin-top: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/css-loader??ref--2-2!/home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/less-loader/dist/cjs.js??ref--2-3!./spa/Pages/Therapists/therapist-top-info.less
// module id = 2588
// module chunks = 19